import Storage from '../StorageManager';

const COOKIE_SELECTED_STORE = 'WC_StLocId_Selected';
const COOKIE_SELECTED_STORE_XT = 'XT_StLocId_Selected';
const COOKIE_STORE_ID = 'WC_StLocId';

/**
 * According to this stack overflow post, we only need to encode comma, white space, and semi-colon
 * https://stackoverflow.com/questions/1969232/allowed-characters-in-cookies/1969339#1969339
 */
const encodeMappings = [
  [/\s/g, '%20'],
  [/,/g, '%2C'],
  [/;/g, '%3B'],
];
const decodeMappings = [
  [/%20/g, ' '],
  [/%2C/g, ','],
  [/%3B/g, ';'],
];

const encode = obj => {
  const str = JSON.stringify(obj);
  return encodeMappings.reduce((result, encodePair) => {
    const [re, encodedVal] = encodePair;
    return result.replace(re, encodedVal);
  }, str);
};

const decode = strObj => {
  const jsonStr = decodeMappings.reduce((result, decodePair) => {
    const [re, decodedVal] = decodePair;
    return result.replace(re, decodedVal);
  }, strObj);
  return JSON.parse(jsonStr);
};

/**
 * Function to set the store data from storage or cookie based on availability
 * @param storeObject
 */
export const setSelectedStoreCookies = storeObject => {
  if (Storage.isLocalStorageAvailable) {
    // local storage is available, use it...
    Storage.setLocalStorage(COOKIE_SELECTED_STORE, storeObject);
  } else if (Storage.isSessionStorageAvailable) {
    // use session storage as local storage is not available
    Storage.setSessionStorage(COOKIE_SELECTED_STORE, storeObject);
  } else {
    // fallback to cookie. should never go here.
    Storage.setCookie(COOKIE_SELECTED_STORE, encode(storeObject));
    Storage.setCookie(COOKIE_SELECTED_STORE_XT, encode(storeObject));
  }
};

/**
 * function to get the store data from storage or cookie as per the availability;
 * @returns {*}
 */
export const getSelectedStoreFromCookies = () => {
  if (Storage.isLocalStorageAvailable) {
    return Storage.getLocalStorage(COOKIE_SELECTED_STORE);
  }
  if (Storage.isSessionStorageAvailable) {
    return Storage.getSessionStorage(COOKIE_SELECTED_STORE);
  }
  // if both of the above does not work, fallback to cookie
  const encodedSelectedStore = Storage.getCookie(COOKIE_SELECTED_STORE) || Storage.getCookie(COOKIE_SELECTED_STORE_XT);
  return encodedSelectedStore ? decode(encodedSelectedStore) : undefined;
};

/**
 * Deletes the store data saved in the browser storage
 */
export const deleteSelectedStoreCookies = () => {
  if (Storage.isLocalStorageAvailable) {
    Storage.removeLocalStorage(COOKIE_SELECTED_STORE);
  } else if (Storage.isSessionStorageAvailable) {
    Storage.removeSessionStorage(COOKIE_SELECTED_STORE);
  } else {
    Storage.deleteCookie(COOKIE_SELECTED_STORE);
    Storage.deleteCookie(COOKIE_SELECTED_STORE_XT);
  }
};

export const deleteBackupSelectedStoreCookie = () => {
  Storage.deleteCookie(COOKIE_SELECTED_STORE_XT);
};

export const getSelectedStore = () => {
  const storeId = Storage.getCookie(COOKIE_STORE_ID);
  if (storeId && storeId !== 'undefined') {
    return storeId;
  }
  return '';
};
